<callback-error>
  <style>
  .bold {
    font-weight: bold;
  }
  ul.attention li {
    margin-left: 1em;
  }
  .bottom_warning{
    width: 60%;
    margin: 2em auto 0 auto;
  }
  </style>
  
  <section class="sec-top-function com-bg-gray">
    <div class="sec-top-inner sec-inner">
      <header class="sec-top-header">
        <h2 class="sec-top__ttl"><span>SNSによるログイン・会員登録でエラーが発生しました</span></h2>
      </header>
    </div>
  </section>

  <div class="com-article-inner">
    <div class="sec-inner">
      <div class="sec-basic-input__wrap com-bg-white">
        <section class="sec-basic-input">
          <div class="com-form">
            <form>
              <div class="com-form__submit">
                <button type="button" class="com-btn-01" onclick="{first}"><span>メールアドレスで会員登録</span></button>
              </div>
              <div class="com-form__submit">
                <button type="button" class="com-btn-01" onclick="{signIn}"><span>メールアドレスでedirecoにログイン</span></button>
              </div>
            </form>
          </div>
        </section>

      </div>
    </div>

  <script>
    import di from 'dependeny-injection'

    export default {
      data: di.register.mailData,
      onMounted(props, states){
        scrollTo(0, 0);
      },
      first(e) {
        di.route.router.push("");
      },
      signIn() {
        location.href="/auth/sign-in";
      }
    }
  </script>
</callback-error>